/*
 * All Lab2-based labs must be registered here.
 *
 * Want to add a new lab? See ./src/lab2/README.md: 'How to Create a New Lab'
 * If you are going to pattern after one lab, start with pythonlab (2024).
 *
 * Note: old-style "lab1" labs use a different system, see webpackEntryPoints.js
 */

import {AIChatEntryPoint} from '@cdo/apps/aichatLab/entrypoint';
import {AilabEntryPoint} from '@cdo/apps/ailab/lab2/entrypoint';
import {BubbleChoiceEntryPoint} from '@cdo/apps/bubbleChoice/entrypoint';
import {DanceEntryPoint} from '@cdo/apps/dance/lab2/entrypoint';
import {JavalabEntryPoint} from '@cdo/apps/javalab/lab2/entrypoint';
import type {Lab2EntryPoint} from '@cdo/apps/lab2/types';
import {MusicEntryPoint} from '@cdo/apps/music/entrypoint';
import {PanelsEntryPoint} from '@cdo/apps/panels/entrypoint';
import {PythonlabEntryPoint} from '@cdo/apps/pythonlab/entrypoint';
import {SketchlabEntryPoint} from '@cdo/apps/sketchlab/entrypoint';
import {StandaloneVideoEntryPoint} from '@cdo/apps/standaloneVideo/entrypoint';
import {Weblab2EntryPoint} from '@cdo/apps/weblab2/entrypoint';

export const lab2EntryPoints = {
  aichat: AIChatEntryPoint,
  ailab: AilabEntryPoint,
  bubble_choice: BubbleChoiceEntryPoint,
  dance: DanceEntryPoint,
  javalab: JavalabEntryPoint,
  music: MusicEntryPoint,
  panels: PanelsEntryPoint,
  pythonlab: PythonlabEntryPoint,
  standalone_video: StandaloneVideoEntryPoint,
  weblab2: Weblab2EntryPoint,
  sketchlab: SketchlabEntryPoint,
} as const satisfies Record<string, Lab2EntryPoint>;
